import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.Double
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface MapControllerTargetLifecycleHooks {
  public fun mapTargetConnected(element: HTMLElement) {
  }

  public fun mapTargetDisconnected(element: HTMLElement) {
  }

  public fun pointTargetConnected(element: HTMLElement) {
  }

  public fun pointTargetDisconnected(element: HTMLElement) {
  }

  public fun zoomValueChanged(`value`: Double, previousValue: Double) {
  }
}

public fun <T : HTMLElement> MapController.mapTarget(): StimulusProperty<T> =
    StimulusProperty("mapTarget")

public fun <T : HTMLElement> MapController.mapTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("mapTargets")

public fun <T : HTMLElement> MapController.pointTarget(): StimulusProperty<T> =
    StimulusProperty("pointTarget")

public fun <T : HTMLElement> MapController.pointTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("pointTargets")

public fun MapController.zoomValue(): StimulusProperty<Double> = StimulusProperty("zoomValue")

public fun MapController.hasZoomValue(): Boolean {
  println(this.asDynamic()["hasZoomValue"])
  return this.asDynamic()["hasZoomValue"]
}

public fun registerMapController(stimulus: Application) {
               val clazz = MapController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "map",
  "point",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("zoom", "Number", false)
                      ),
                      MapController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "map"
              println("Registering controller map")

              stimulus.register(controllerName, factoryFunc)
}
